import ResizableSplitLayout from "../../Components/ResizableComponent";

function Elements() {
  return <ResizableSplitLayout />;
}

export default Elements;
